module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6f8dd016f007f80d2e79c5bac02aa21.png";